module.exports = __webpack_public_path__ + "static/media/09-04.62a13673.png";